export default __webpack_public_path__ + "static/media/ies_TonyEsposito.99ea09a0.png";